import { Text } from '@kanda-libs/ks-design-library';

import { House } from 'lucide-react';

import AddressFieldsWrapper from './AddressFieldsWrapper';
import useAddressesInformationFields from './useAddressesInformationFields';

import { YOUR_INFO_CLASS_NAMES } from '../constants';

const AddressesInformationFields: React.FunctionComponent = function () {
  const { previousAddress1Visible, previousAddress2Visible } =
    useAddressesInformationFields();
  return (
    <>
      <div className="flex flex-col mb-3">
        <div className="flex flex-row gap-x-3 items-center mb-2">
          <House size={20} />
          <Text className={YOUR_INFO_CLASS_NAMES.title} text="Address(es)" />
        </div>
        <Text
          className="text-14-22 text-neutral-700"
          text="We need address history for at least the last 3 years"
        />
      </div>
      <AddressFieldsWrapper addressType="current" />
      {previousAddress1Visible && (
        <>
          <div className="w-full border-b border-neutral-300 mx-auto mb-4" />
          <AddressFieldsWrapper addressType="previous1" />
        </>
      )}
      {previousAddress2Visible && (
        <>
          <div className="w-full border-b border-neutral-300 mx-auto mb-4" />
          <AddressFieldsWrapper addressType="previous2" />
        </>
      )}
    </>
  );
};

export default AddressesInformationFields;
